import config from '../config'
import { authorizedFetch } from '../utils/auth.js'
import { logOut } from '../actions/users'
import { checkStatus } from '../utils/fetch'
const JSON = require('circular-json')

export const REQUEST_BUILDINGS = 'REQUEST_BUILDINGS'
export const RECEIVED_BUILDINGS = 'RECEIVED_BUILDINGS'
export const SHOW_NEW_USER_REPORTS_DIALOG = 'SHOW_NEW_USER_REPORTS_DIALOG'
export const SHOW_ACTIVE_USER_REPORTS_DIALOG = 'SHOW_ACTIVE_USER_REPORTS_DIALOG'
export const CLOSE_USER_REPORTS_DIALOG = 'CLOSE_USER_REPORTS_DIALOG'
export const UPDATE_DATE_START = 'UPDATE_DATE_START'
export const UPDATE_DATE_END = 'UPDATE_DATE_END'
export const CLOSE_RECEIVE_NEWSLETTER_REPORTS_DIALOG = 'CLOSE_RECEIVE_NEWSLETTER_REPORTS_DIALOG'
export const SHOW_RECEIVE_NEWSLETTER_REPORTS_DIALOG = 'SHOW_RECEIVE_NEWSLETTER_REPORTS_DIALOG'
export const FETCH_COMMUNITY_REPORTS_SUCCEEDED = 'FETCH_COMMUNITY_REPORTS_SUCCEEDED'
export const SELECT_ACTIVE_BUILDING = 'SELECT_ACTIVE_BUILDING'
export const UPDATE_ACTIVE_BUILDING = 'UPDATE_ACTIVE_BUILDING'
export const UPDATE_FILTER = 'UPDATE_FILTER'

export const fetchUsersReports = withEmail => dispatch => {
  authorizedFetch(config.api_url + `reports/users?withEmail=${withEmail}`)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const fetchBookingReports = () => dispatch => {
  authorizedFetch(config.api_url + 'reports/bookings')
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const fetchProgramReports = () => dispatch => {
  authorizedFetch(config.api_url + 'reports/programs?')
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      dispatch(logOut())
    })
}
export const fetchActiveUsersReports = (startDate, endDate) => dispatch => {
  // console.log('startDate:' + )
  // console.log('valueEnd:' + )
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'reports/activeUsers', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ startDate: startDate, endDate: endDate })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      console.log(error)
      dispatch(logOut())
    })
}
export const fetchNewUsersReports = (startDate, endDate) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'reports/newUsers', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ startDate: startDate, endDate: endDate })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      console.log(error)
      dispatch(logOut())
    })
}

export const fetchBuildingsReports = (building_id, withEmail) => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'reports/buildings', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building_id: building_id, withEmail })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      console.log(error)
      dispatch(logOut())
    })
}

export const fetchCommunityReports = building_id => dispatch => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  headers.append('Access-Control-Allow-Origin', '*')
  headers.append('Accept', 'application/json')

  authorizedFetch(config.api_url + 'reports/community', {
    headers: headers,
    mode: 'cors',
    cache: 'default',
    method: 'POST',
    body: JSON.stringify({ building_id: building_id })
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      let downloadUrl = json['download_url']
      window.open(downloadUrl, '_blank')
    })
    .catch(function(error) {
      console.log(error)
      dispatch(logOut())
    })
}

// export const updateBuilding = (building) => dispatch => {

//   var headers = new Headers()
//   headers.append('Content-Type', 'application/json');
//   headers.append('Access-Control-Allow-Origin', '*');
//   headers.append('Accept', 'application/json');

//   authorizedFetch(config.api_url + 'buildings/update',
//     {
//       headers: headers,
//       mode: 'cors',
//       cache: 'default',
//       method: "POST",
//       body: JSON.stringify({ building : building })
//     })
//     .then(checkStatus)
//     .then(response => response.json())
//     .then(json => dispatch(updateBuildingSucceded(json)))
//     .catch(function(error) {
//       dispatch(logOut())
//     });
// }

export const receivedBuildings = (json, building_id) => ({
  type: RECEIVED_BUILDINGS,
  json: json.data,
  building_id: building_id
})

export const fetchBuildings = () => dispatch => {
  dispatch(requestBuildings())
  authorizedFetch(config.api_url + 'buildings/list')
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receivedBuildings({ data: json })))
    .catch(function(error) {
      dispatch(logOut())
    })
}

export const requestBuildings = () => ({
  type: REQUEST_BUILDINGS
})

export const showNewUserReportsDialog = () => ({
  type: SHOW_NEW_USER_REPORTS_DIALOG
})

export const showActiveUserReportsDialog = () => ({
  type: SHOW_ACTIVE_USER_REPORTS_DIALOG
})

export const closeUserReportsDialog = () => ({
  type: CLOSE_USER_REPORTS_DIALOG
})

export const closeReceiveNewsletterReportsDialog = () => ({
  type: CLOSE_RECEIVE_NEWSLETTER_REPORTS_DIALOG
})
export const showReceiveNewsletterReportsDialog = () => ({
  type: SHOW_RECEIVE_NEWSLETTER_REPORTS_DIALOG
})

export const updateDateStart = (name, value) => ({
  type: UPDATE_DATE_START,
  name: name,
  value: value
})

export const updateDateEnd = (name, value) => ({
  type: UPDATE_DATE_END,
  name: name,
  value: value
})

export const fetchCommunityReportsSucceeded = () => ({
  type: FETCH_COMMUNITY_REPORTS_SUCCEEDED
})

export const selectActivateBuilding = buildingId => ({
  type: SELECT_ACTIVE_BUILDING,
  newsletterBuildingId: buildingId
})
export const updateActiveBuilding = buildingId => ({
  type: UPDATE_ACTIVE_BUILDING,
  selectedBuildingId: buildingId
})

export const updateFilter = (filter, value) => ({
  type: UPDATE_FILTER,
  filter: filter,
  value: value
})



// WEBPACK FOOTER //
// ./src/actions/reports.js